import { createSlice } from '@reduxjs/toolkit';
import { fetchRoles } from 'common/services/api/Roles/Roles.thunk';
import { Role } from 'common/types/Entities';
import { createLoadedExtraReducers } from 'common/utils/sliceUtils/entitySliceUtils';
import { filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

interface RolesState extends FilterState {
    roles: Role[];
    loaded: boolean;
}

type StateWithRoles = { roles: RolesState };

const initialState: RolesState = {
    roles: [],
    loaded: false,
    filters: {
        keywords: [],
    }
};

const rolesSlice = createSlice({
    name: 'roles',
    initialState,
    reducers: () => ({
        ...filterReducers,
    }),

    extraReducers: builder => {
        createLoadedExtraReducers<Role>(builder, fetchRoles, 'roles');
    }
});

// eslint-disable-next-line no-restricted-syntax
export default rolesSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = rolesSlice.actions;
export const selectFilters = (state: StateWithRoles) => state.roles.filters;
export const selectRoles = (state: StateWithRoles) => state.roles.roles;
